import { ComponentPropsWithoutRef, forwardRef } from "react";

import classNames from "classnames";

import styles from "./StyledNativeInput.module.scss";

/**
 * A shared text area element backed by form SCSS.
 */
export type StyledNativeInputProps = ComponentPropsWithoutRef<"textarea">;

export const StyledNativeInput = forwardRef<HTMLTextAreaElement, StyledNativeInputProps>(function StyledNativeInput(
  { className, ...props },
  ref,
) {
  return <textarea {...props} className={classNames(styles.NativeInput, className)} ref={ref} />;
});
